<template>
  <el-dialog
    :title="title"
    :visible.sync="show"
    :center="true"
     width="600px">
    <div style="width: 100%; height: 100%;" v-loading="loading">
      <div class="w100 pl20 pr20 pt20 pb20">
        <el-form label-width="100px" :model="form" :rules="rules" ref="ruleForm" class="demo-form-inline">
          <el-form-item label="标题" prop="title" style="min-width: 250px;">
            <el-input v-model="form.title" placeholder="请输入标题"></el-input>
          </el-form-item>
          <el-form-item label="内容" prop="con" style="width: 100%; min-width: 250px;">
            <el-input v-model="form.con" type="textarea" :rows="2" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="附件" prop="fileList" style="width: 380px;">
            <el-upload
              class="upload-demo"
              ref="fileUpload"
              action="/hallportal/file/upload"
              :headers="uploadHeader"
              accept=".txt, .docx, .xls"
              :on-change="fileChange"
              :on-remove="fileRemove"
              :file-list="form.fileList"
              :before-remove="fileBeforeRemove"
              :on-success="fileSuccess"
              :auto-upload="false"
              :limit="1"
              :on-exceed="handleExceed">
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
              <div slot="tip" class="el-upload__tip">只能上传.txt, .docx, .xls文件，且不超过1M。</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="匿名提交" style="width: 40%; min-width: 250px;">
            <el-switch v-model="form.state" active-color="#409EFF" inactive-color="#cdcdcd"></el-switch>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="show = false">取 消</el-button>
      <el-button @click="submitForm('ruleForm')" type="primary">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AddComplain",
  components: {},
  props: ["prorData"],
  data() {
    return {
      show: false,
      loading: false,
      title: "",
      fileUploadData: { folderId: "aa" },
      // uploadUrl: this.$http.defaults.baseURL + "/file/upload", // 上传地址
      uploadHeader: {},
      form: {
        title: "",
        con: "",
        fileList: [],
        state: false
      },
      rules: {
        title: [
          { required: true, message: "请输入标题", trigger: "blur" }
        ],
        con: [
          { required: true, message: "请输入内容", trigger: "blur" }
        ],
        fileList: [
          { required: true, message: "请上传附件", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["userToken", "userData"])
  },
  created() {},
  mounted() {
    this.uploadHeader = { token: this.userToken }
  },
  destroyed() {},
  methods: {
    // 显示弹框
    dialogShow () {
      // 重置表单、显示弹框
      this.show = true;
      this.$nextTick(function(){
        this.$refs["ruleForm"].resetFields();
        this.title = "新增建议";
      });
    },

    // 确定提交
    submitForm (formName) {
      this.loading = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$refs.fileUpload.submit() // 上传附件
        } else {
          this.loading = false;
          return false;
        }
      });
    },

    // 新增 提交方法
    submitFn (id) {
      let data = {
        title: this.form.title,
        content: this.form.con,
        fileId: id,
        userName: this.form.state ?  "匿名" : this.userData.userName
      }

      if (!id) {
        this.loading = false;
        this.form.fileList = [];
        this.$message.error("附件上传失败，请重新选择附件！");
        return
      }

      this.$http.post( "/complaint/add", data )
      .then( ({ data }) => {
        if ( data.resCode === 0 ) {
          this.$message.success("投诉内容新增成功！");
        }
        this.loading = false;
        this.show = false;
      })
      .catch( () => {
        this.show = false;
        this.loading = false;
        this.$message.error("网络错误！");
      });
    },

    // 上传附件
    fileChange (file, fileList) {
      const isJPG = file.raw.type === "text/plain" || file.raw.type === "application/vnd.ms-excel" || file.raw.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      const isLt2M = file.size / 1024  < 1024;
      const isSize = file.size;

      if (!isSize) {
        this.$refs.fileUpload.clearFiles();
        this.$message.error('该文件内容为空，请重新选择。');
        return;
      }
      if (!isJPG) {
        this.$refs.fileUpload.clearFiles();
        this.$message.error('上传文件只能是 .txt, .docx, .xls 格式文件!');
        return;
      }
      if (!isLt2M) {
        this.$refs.fileUpload.clearFiles();
        this.$message.error('上传文件大小不能超过 1MB!,请重新上传。');
        return;
      }

      this.form.fileList = fileList;
    },

    // 上传成功
    fileSuccess (response, file) {
      this.$nextTick(() => {
        this.submitFn(response.resData)
      })
    },
    // 移除文件
    fileRemove(file) {
      this.form.fileList = [];
      this.$message.success("文件 " + file.name + " 移除成功！");
    },
    // 文件移除提示
    fileBeforeRemove(file) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    handleExceed() {
      this.$message.warning("只支持上传 1 个文件");
    }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
  .title {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 1px solid #f1f2f3;
    padding-bottom: 12px;
  }

  .title span {
    color: #409EFF;
    font-size: 16px;
  }

  .el-form {
    padding-top: 20px;
  }

  .avatar-uploader {
    width: 32px;
    height: 32px;
    display: block;
    border: 1px solid #cdcdcd;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .avatar-uploader .avatar {
    width: 32px;
    height: 32px;
    display: block;
  }
</style>
